<template>
  <base-page-layout title="Perfil demográfico" class="perfil-demografico" :filters="['clube', 'segmentos']" default-date="desdeInicio">
    <template v-slot:header>
      <demographic-profile-pdf :person-type="personType" />
    </template>
    <v-container fluid grid-list-lg class="pa-0">
      <v-tabs v-model="activeTab" background-color="white" slider-color="primary" grow>
        <v-tab ripple @click="selectTab('F')">Pessoa física</v-tab>
        <v-tab ripple @click="selectTab('J')">Pessoa jurídica</v-tab>
      </v-tabs>
      <v-divider />

      <v-layout v-if="personType === 'F'" wrap class="pa-0">
        <v-flex xs12 class="py-0">
          <faixa-etaria-card />
        </v-flex>
        <v-flex xs12 class="py-0">
          <v-divider />
          <cidade-card tipo-pessoa="F" :not-resolved-clients="notResolvedClients" />
        </v-flex>
        <v-flex xs12 class="py-0">
          <v-divider />
          <bairro-card tipo-pessoa="F" :not-resolved-clients="notResolvedClients" />
        </v-flex>
        <v-flex xs12 class="py-0">
          <v-divider />
          <genero-card />
        </v-flex>
      </v-layout>

      <v-layout v-if="personType === 'J'" wrap class="pa-0">
        <v-flex xs12 class="py-0">
          <cidade-card tipo-pessoa="J" />
        </v-flex>
        <v-flex xs12 class="py-0">
          <bairro-card tipo-pessoa="J" />
        </v-flex>
      </v-layout>
    </v-container>
  </base-page-layout>
</template>

<script>
import BasePageLayout from '@/components/BasePageLayout.vue'
import FaixaEtariaCard from '@/modules/clientes/perfil-demografico/views/pages/FaixaEtariaCard.vue'
import CidadeCard from '@/modules/clientes/perfil-demografico/views/pages/CidadeCard.vue'
import BairroCard from '@/modules/clientes/perfil-demografico/views/pages/BairroCard.vue'
import GeneroCard from '@/modules/clientes/perfil-demografico/views/pages/GeneroCard.vue'
import DemographicProfilePdf from '../components/DemographicProfilePdf.vue'
import { mapState } from 'vuex'
import { mapWaitingActions } from 'vue-wait'
export default {
  components: {
    BasePageLayout,
    FaixaEtariaCard,
    CidadeCard,
    BairroCard,
    GeneroCard,
    DemographicProfilePdf,
  },
  data: () => ({
    personType: 'F',
    activeTab: 0,
    notResolvedClients: 0,
  }),
  computed: {
    ...mapState({
      stateFilters: (state) => state.filters,
    }),
    filterGeo() {
      return {
        tipo_pessoa: this.personType,
        segmentos: this.stateFilters.segments,
        kpi: 'clientes_cadastrados',
      }
    },
    baseFilter() {
      return {
        unidades: this.stateFilters.units,
        fidelidade: this.stateFilters.fidelidade,
        categoria_cliente: this.stateFilters.cliente,
        segmentos: this.stateFilters.segments,
      }
    },
    ageRangeFilter() {
      return {
        ...this.baseFilter,
        tipo_pessoa: 'F',
        group_field: 'faixa_etaria',
      }
    },
    cityFilter() {
      return {
        ...this.baseFilter,
        group_field: 'cod_cidade',
      }
    },
    neighborhoodFilter() {
      return {
        ...this.baseFilter,
        group_field: 'bairro',
      }
    },
    genderFilter() {
      return {
        ...this.baseFilter,
        tipo_pessoa: 'F',
        group_field: 'genero',
      }
    },
  },
  watch: {
    async 'stateFilters.segments'() {
      await this.getData()
    },
  },
  methods: {
    ...mapWaitingActions({
      getClientesGeoStatus: 'geo-status',
      perfilDemograficoFaixa: 'faixa',
      perfilDemograficoCidadeFisica: 'cidade-fisica',
      perfilDemograficoCidadeJuridica: 'cidade-juridica',
      perfilDemograficoBairroFisica: 'bairro-fisica',
      perfilDemograficoBairroJuridica: 'bairro-juridica',
      perfilDemograficoGenero: 'genero',
    }),
    async selectTab(type) {
      this.personType = type
      await this.getData()
    },
    getNotResolvedClients() {
      this.getClientesGeoStatus(this.filterGeo).then((data) => {
        this.notResolvedClients = data['NUM_CLIENTES_NAO_RESOLVIVEIS']
      })
    },
    async getData() {
      await this.getNotResolvedClients()
      if (this.personType === 'F') {
        await this.getNaturalPersonData()
      } else {
        await this.getLegalPersonData()
      }
    },
    async getNaturalPersonData() {
      await Promise.all([
        this.perfilDemograficoFaixa(this.ageRangeFilter),
        this.perfilDemograficoCidadeFisica(this.cityFilter),
        this.perfilDemograficoBairroFisica(this.neighborhoodFilter),
        this.perfilDemograficoGenero(this.genderFilter),
      ])
    },
    async getLegalPersonData() {
      await Promise.all([await this.perfilDemograficoCidadeJuridica(this.cityFilter), await this.perfilDemograficoBairroJuridica(this.neighborhoodFilter)])
    },
  },
}
</script>

<style lang="scss">
.perfil-demografico {
  .filter-buttons {
    position: relative;
    top: 42px;
  }
}
</style>
